import type { CustomFieldDef } from '@prisma/client';

type Values = Record<string, string | number | boolean | null> | undefined;

/** Returns a message describing the first problem with custom field values, or null when valid. */
export function customFieldError(
  defs: Pick<CustomFieldDef, 'key' | 'label' | 'type' | 'options' | 'required'>[],
  values: Values,
): string | null {
  const provided = values ?? {};
  const known = new Map(defs.map((d) => [d.key, d]));
  for (const key of Object.keys(provided)) {
    if (!known.has(key)) return `Unknown custom field "${key}"`;
  }
  for (const def of defs) {
    const v = provided[def.key];
    const empty = v === undefined || v === null || v === '';
    if (empty) {
      if (def.required) return `${def.label} is required`;
      continue;
    }
    if (def.type === 'number' && typeof v !== 'number' && !/^-?\d+(\.\d+)?$/.test(String(v)))
      return `${def.label} must be a number`;
    if (def.type === 'date' && !/^\d{4}-\d{2}-\d{2}$/.test(String(v)))
      return `${def.label} must be a date (YYYY-MM-DD)`;
    if (def.type === 'select' && !((def.options as string[] | null) ?? []).includes(String(v)))
      return `${def.label}: choose one of the listed options`;
    if (def.type === 'text' && String(v).length > 500) return `${def.label} is too long`;
  }
  return null;
}
